/**
 * Full-page navigation to Google. Its own module so tests can mock it; jsdom does not implement
 * navigation.
 */
export function leaveApp(url: string): void {
  window.location.assign(url);
}
